import { NgxSpinnerService } from "ngx-spinner";
import { NavigationService } from "src/app/core/services/navigation.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Deployment } from "src/app/core/models/deployment";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  interval,
  Subscription,
  lastValueFrom,
  combineLatest,
  Subject,
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  map,
} from "rxjs";
import { UserService } from "src/app/core/services/user.service";
import { MatDialog } from "@angular/material/dialog";
import { UserRoleNames, UserRolesInt, Users } from "src/app/core/models/users";
import { AddUserComponent } from "../../modals/add-user/add-user.component";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import { Entities, ImportCSVType } from "src/app/core/models/globals";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl, FormGroup, UntypedFormControl } from "@angular/forms";
import { BulkAddUserComponent } from "../../modals/bulk-add-user/bulk-add-user.component";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { EditColoumsComponent } from "../../../node/modals/edit-coloums/edit-coloums.component";
import { HeaderService } from "../../../../core/services/header.service";
import { User } from "../../../../core/models/user";
import { DeleteUserComponent } from "../../modals/delete-user/delete-user.component";
import { CsvExportService } from "src/app/core/services/csv-export.service";
import { BillingInputComponent } from "../../modals/billing-input/billing-input.component";
import { ConsumptionService } from "src/app/core/services/consumption.service";
import { BillingPreviewComponent } from "../../modals/billing-preview/billing-preview.component";
import { UpdateUserComponent } from "../../modals/update-user/update-user.component";
import { ResetPassConfirmationComponent } from "../../modals/reset-pass-confirmation/reset-pass-confirmation.component";
import { NotificationConfigurationComponent } from "../../modals/notification-configuration/notification-configuration.component";

@Component({
  selector: "app-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"],
})
export class UserListComponent implements OnInit, OnDestroy {
  columnInfo = {
    columnsOfComponents: [],
    coloumToShow: [],
  };
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  deploymentFilterShow: boolean = this.loggedInUserRole === "Deployment Admin";
  isJobOperator: boolean =
    this.loggedInUserRole === "Job Operator" || this.loggedInUserRole === "";
  canAddUser: boolean = this.loggedInUserRole === "Global Admin";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;
  deployments: Deployment[];
  userRoleList: string[] = [
    UserRoleNames.GlobalAdmin,
    UserRoleNames.DeploymentAdmin,
    UserRoleNames.JobOperator,
    "Unassigned",
  ];
  allocatedCoresList: number[] = [];
  selectedDeployment: string = "All";
  filterUser: Users[];
  users: Users[];
  depName =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  detailsLoaded;
  currentEntity;
  p: number = 1; // count of pagination;
  curIndex: number = 0;
  activeChild = 1;
  allUserEmails = [];
  allUserNames = [];
  totalUsersAdded: number;
  maxAllowedUser: number;
  addUserToIdentityServer: boolean = true;
  editColumn = new UntypedFormControl("");
  columnList: string[] = ["First Name", "Last Name"];
  editedColumnList: string[] = [];
  mappedWorkstations: any = [];
  mapped: any = [];
  multiSelectIndex = [];
  isSelectAll: boolean = false;
  canDeleteUsers: string[] = [];
  usersList: Users[] = [];
  loginTimeSort: boolean = false;
  toShowFilter: boolean = false;
  itemsPerPage = 10;
  entriesNumber = 10;
  destroySub$ = new Subject();
  searchTerm = new FormControl("");
  filterForm = new FormGroup({
    deployment: new FormControl<string>("All"),
    userRole: new FormControl<string>("All"),
    allocatedCores: new FormControl<string>("All"),
    machine: new FormControl<string>("All"),
  });
  config = {
    itemsPerPage: 10,
    currentPage: 1,
  };
  userRoleFilterOptions = [
    { key: "All Role", value: "All" },
    { key: UserRoleNames.GlobalAdmin, value: 0 },
    { key: UserRoleNames.DeploymentAdmin, value: 1 },
    { key: UserRoleNames.JobOperator, value: 3 },
    { key: UserRoleNames.Reader, value: 4 },
    { key: "Unassigned", value: 5 },
  ];
  detailsViewOpen: boolean = false;
  private lastUrl = '';
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private depService: DeploymentService,
    private router: Router,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private syncConfig: SyncConfigService,
    private snackBar: MatSnackBar,
    private headerService: HeaderService,
    private csvExportService: CsvExportService,
    private consumptionService: ConsumptionService
  ) {
    this.lastUrl = decodeURI(this.router.url);
    if (!this.router.url.includes('/user/')) {
      this.detailsViewOpen = false;
    }
  }

  ngDoCheck() {
    const currentUrl = decodeURI(this.router.url);

    if (currentUrl !== this.lastUrl) {
      this.lastUrl = currentUrl;

      if (currentUrl === '/Users List/users') {
        this.detailsViewOpen = false;
      }
    }
  }

  ngOnDestroy() {
    this.destroySub$.next(true);
    this.destroySub$.complete();
    document.body.classList.remove('text-grey-overlay');
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;

    // Only process if URL changed
    if (currentUrl !== this.lastUrl) {
      this.lastUrl = currentUrl;

      // Check if we're on the main list route
      if (currentUrl === '/Users List/users' ||
        currentUrl === '/Users%20List/users') {
        this.detailsViewOpen = false;
      }
    }
    this.detailsViewOpen = false;
    this.spinner.show("userList");
    this.createLocalStorage();
    this.navService.breadcrumbEntity
      .pipe(takeUntil(this.destroySub$))
      .subscribe((x) => {
        this.currentEntity = x;
      });
    this.navService.sendParentData(Entities.Users);
    if (this.currentEntity == Entities.Users) {
      this.navService.sendLeftPanelIndex(0);
    } else {
      this.navService.sendLeftPanelIndex(5);
    }
    this.loadUserData(this.depName);
    interval(this.syncConfig.config.users.listReqInterval)
      .pipe(takeUntil(this.destroySub$))
      .subscribe((x) => {
        this.loadUserData(this.depName);
        this.navService.sendLastUpdate(this.headerService.getUserNewDate());
      });

    this.userService
      .getAddUserToIdentityServerFlag()
      .pipe(takeUntil(this.destroySub$))
      .subscribe((data) => {
        this.addUserToIdentityServer = !!data;
      });

    this.depService.getAllDeploymentsForUser().subscribe((data) => {
      let infoes = <Deployment[]>JSON.parse(JSON.stringify(data));
      this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
      this.maxAllowedUser = this.deployments[0]?.maxAllowedUsers || 0;

      const childRoute = this.route.firstChild;
      const filterDeploymentName = childRoute?.snapshot.paramMap.get('filterDeploymentName');
      if (filterDeploymentName) {
        this.toShowFilter = true;
        setTimeout(() => {
          this.filterForm.get('deployment')?.setValue(filterDeploymentName);
        }, 0);
      }
    });

    this.userService.toReload
      .pipe(takeUntil(this.destroySub$))
      .subscribe((x) => {
        if (x) {
          this.spinner.show("userList");
          this.loadUserData(this.depName);
        }
      });
    this.filterForm.valueChanges.subscribe((res) => {
      this.applyFilter();
    });
    this.searchTerm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroySub$)
      )
      .subscribe((val: string) => {
        this.onSearch(val?.toLowerCase());
      });
  }

  ngAfterViewInit() {
    document.body.classList.add('text-grey-overlay');
  }

  loadUserData(depName: string) {
    if (depName) {
      this.userService
        .getAllDeploymentUsers(this.depName)
        .pipe(takeUntil(this.destroySub$))
        .subscribe((data) => {
          this.loadUsersAfterREST(data);
        });
    } else {
      this.userService
        .getAllUsers()
        .pipe(takeUntil(this.destroySub$))
        .subscribe((data) => {
          this.loadUsersAfterREST(data);
        });
    }
  }

  loadUsersAfterREST(userData) {
    if (userData && userData.length > 0) {
      const currentPage = this.config.currentPage;
      const itemPerPage = this.config.itemsPerPage;
      const currentSearchTerm = this.searchTerm.value;
      this.users = <Users[]>JSON.parse(JSON.stringify(userData));
      this.users.sort((a, b) => (a.userName < b.userName ? -1 : 1));
      this.onSearch(currentSearchTerm);
      this.totalUsersAdded = this.users.length;
      let currSelectedIndex = 0;
      if(!this.selectedUser || !this.selectedUser.userName) {
        currSelectedIndex =
          this.curIndex == 0
            ? this.curIndex
            : (currentPage == 1 ? 0 : (currentPage - 1) * itemPerPage) + this.curIndex;
      }else{
        currSelectedIndex = this.users.findIndex((x) => x.userName === this.selectedUser.userName);
      }

      this.allUserEmails = [];
      if(this.filterUser[currSelectedIndex]) {
        this.selectedUser = this.filterUser[currSelectedIndex];
        this.userService.activeUserName.set(this.selectedUser.userName);
        this.userService.sendUserName(this.selectedUser.userName);
        this.detailsLoaded = true;
        this.manageUserEmailsAndNames();
        this.users.forEach((user) => {
          if (!this.allocatedCoresList.includes(user.allocatedCoreQuota)) {
            this.allocatedCoresList.push(user.allocatedCoreQuota);
          }
        });
        this.allocatedCoresList.sort((n1, n2) => n1 - n2);
        this.spinner.hide("userList");
        this.mappedWorkstations = this.users
          ?.filter(function (obj) {
            return obj?.userDetails?.find((us) => us?.mappedWorkstation != null);
          })
          .map(function (obj) {
            return obj;
          });
        this.mappedWorkstations?.forEach((item) => {
          item.userDetails?.forEach((i) => {
            if (i.mappedWorkstation != null) {
              if (!this.mapped?.includes(i.mappedWorkstation)) {
                this.mapped.push(i.mappedWorkstation);
              }
            }
          });
        });
        this.applyFilter();
      }
      else {
        this.spinner.hide("userList");
        this.detailsLoaded = false;
      }

    } else {
      this.users = [];
      this.filterUser = [];
      this.spinner.hide("userList");
    }
  }

  manageUserEmailsAndNames() {
    this.users.forEach((x) => {
      if (x.emailId && x.emailId.includes(",")) {
        let tempEmailArr = x.emailId.split(",");
        let length = x.emailId.split(",").length;
        for (let i = 0; i < length; i++) {
          this.allUserEmails.push(tempEmailArr[i]);
        }
      } else {
        this.allUserEmails.push(x.emailId);
      }
      this.allUserNames.push(x.userName);
    });
  }

  selectedUser: Users = null;
  redirectTo(user, index) {
    this.activeChild = 1;
    this.curIndex = index;
    this.selectedUser = user;
    this.userService.activeUserName.set(this.selectedUser.userName);
    this.userService.sendUserName(user.userName);
    this.router.navigate(['user',user.userName], { relativeTo: this.route });
    this.spinner.hide("userList");
  }

  toggleDetailsView(user) {
    if(this.selectedUser?.userName === user.userName && this.detailsViewOpen) {
      this.detailsViewOpen = false;
    } else {
      this.detailsViewOpen = true;
    }
  }

  hideDetails() {
    this.detailsViewOpen = false;
  }

  handleAction(action: string) {
    setTimeout(() => {
      (document.activeElement as HTMLElement)?.blur();
    }, 0);

    switch (action) {
      case "Reset":
        this.resetUserPassword();
        break;
      case "Edit":
        this.editUser();
        break;
      case "Notify":
        this.configureNotifications();
        break;
      case "Delete":
        this.deleteUser();
        break;
      default:
        this.snackBar.open("Invalid Action", "Ok", { duration: 3000 });
        break;
    }
  }

  addUser() {
    const dialogRef = this.dialog.open(AddUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "50%", // Slightly increased width for better layout
      height: "70%", // Increased height to accommodate sticky layout
      maxWidth: "90vw", // Responsive max width
      maxHeight: "90vh", // Responsive max height
      data: {
        userEmail: this.allUserEmails,
        userNames: this.allUserNames,
        addedUsers: this.totalUsersAdded,
        maxAllowedUser: this.maxAllowedUser,
        addUserToIdentityServer: this.addUserToIdentityServer,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.spinner.show("userList");
        this.userService.addUser(res).subscribe({
          next: (data: any) => {
            this.loadUserData(this.depName);
            this.snackBar.open(data, "Ok", { duration: 5000 });
            this.spinner.hide("userList");
          },
          error: (err: any) => {
            this.spinner.hide("userList");
          },
        });
      }
    });
  }

  addBulkUser() {
    const dialogRef = this.dialog.open(BulkAddUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {
        importType: ImportCSVType.Users,
        requiredParams:
          "firstName,lastName,emailId,userName,password,userRole,deployment,publicKey",
        uniqueFields: "Username and EmailId",
      },
    });
  }

  loadUserDetails() {
    this.activeChild = 1;
    this.router.navigate([this.selectedUser.userName], {
      relativeTo: this.route,
    });
  }

  loadAccessControl() {
    this.activeChild = 2;
    this.router.navigate([this.selectedUser.userName, "access-control"], {
      relativeTo: this.route,
    });
  }

  getUserRoleId(userRole) {
    if (userRole == UserRoleNames.GlobalAdmin) {
      return 0;
    } else if (userRole == UserRoleNames.DeploymentAdmin) {
      return 1;
    } else if (userRole == UserRoleNames.PowerUser) {
      return 2;
    } else if (userRole == UserRoleNames.JobOperator) {
      return 3;
    } else if (userRole == "Unassigned") {
      return 5;
    }
  }

  getUserBySelectedDepNameAndUserRole(userRole) {
    if (this.selectedDeployment === "All") {
      this.users = this.users.filter((x) => {
        return x.userRole === userRole;
      });
      return;
    }
    let userRoleId = this.getUserRoleId(userRole);
    this.userService
      .getUsersByUserRoleAndDeployment(this.selectedDeployment, userRoleId)
      .pipe(takeUntil(this.destroySub$))
      .subscribe((data) => {
        this.users = <Users[]>JSON.parse(JSON.stringify(data));
      });
  }

  applyFilter() {
    let filteredUsers = [...this.users];
    const deployment = this.filterForm.get("deployment").value;
    const userRole = this.filterForm.get("userRole").value;
    const allocatedCores = this.filterForm.get("allocatedCores").value;
    const machine = this.filterForm.get("machine").value;
    let skipUser = false;
    if (deployment !== "All") {
      if (deployment == "Unassigned") {
        filteredUsers = filteredUsers.filter((user) =>
          user.userDetails.find((us) => !us.deploymentName)
        );
      } else {
        filteredUsers = filteredUsers.filter((user) =>
          user.userDetails.find((us) => us.deploymentName == deployment)
        );
      }
    }
    if (userRole == "5") {
      filteredUsers = filteredUsers.filter((user) => {
        if (user.adminId === null) {
          return false;
        }
        return user.userDetails.some(
          (detail) => detail.deploymentName === null
        );
      });
      skipUser = true;
    }
    if (userRole == "0") {
      filteredUsers = filteredUsers.filter((user) =>
        user.userDetails.find(
          (us) => us.userRole == userRole && user.adminId === null
        )
      );
    }
    if (userRole !== "All" && !skipUser) {
      filteredUsers = filteredUsers.filter((user) =>
        user.userDetails.find((us) => us.userRole == userRole)
      );
    }
    if (allocatedCores !== "All") {
      filteredUsers = filteredUsers.filter(
        (user) => user.allocatedCoreQuota == Number(allocatedCores)
      );
    }
    if (machine !== "All") {
      filteredUsers = filteredUsers.filter((user) =>
        user.userDetails.find((us) => us.mappedWorkstation == machine)
      );
    }
    this.filterUser = [...filteredUsers];
    const currentSearch = this.searchTerm.value;
    if (currentSearch && currentSearch.trim() !== '') {
      this.onSearch(currentSearch);
    }
    return this.filterUser;
  }

  resetFilter() {
    this.filterForm.patchValue({
      deployment: "All",
      userRole: "All",
      allocatedCores: "All",
      machine: "All",
    });
    this.searchTerm.setValue("");
    this.applyFilter();
  }

  createLocalStorage() {
    let columnInfoObject = JSON.parse(
      localStorage.getItem("userListColumnsInfo")
    );
    if (!columnInfoObject) {
      this.columnInfo.columnsOfComponents = [
        "First Name",
        "Last Name",
        "Email Id",
      ];
      this.columnInfo.coloumToShow = ["Email Id"];
      this.editedColumnList = [...this.columnInfo.coloumToShow];
      localStorage.setItem(
        "userListColumnsInfo",
        JSON.stringify(this.columnInfo)
      );
    } else {
      this.columnInfo.columnsOfComponents =
        columnInfoObject.columnsOfComponents;
      this.columnInfo.coloumToShow = columnInfoObject.coloumToShow;
      this.editedColumnList = [...this.columnInfo.coloumToShow];
    }
  }

  editColoum() {
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length > 0) {
          this.editedColumnList = [];
          res.data.forEach((el) => {
            this.editedColumnList = [...this.editedColumnList, el.name];
          });
          this.columnInfo = {
            ...this.columnInfo,
            coloumToShow: [...this.editedColumnList],
          };
          localStorage.setItem(
            "userListColumnsInfo",
            JSON.stringify(this.columnInfo)
          );
        } else {
          this.editedColumnList = [];
          this.columnInfo = {
            ...this.columnInfo,
            coloumToShow: this.editedColumnList,
          };
          localStorage.setItem(
            "userListColumnsInfo",
            JSON.stringify(this.columnInfo)
          );
        }
      }
    });
  }

  showAllEntriesMethod() {
    if (this.entriesNumber > 0) {
      this.itemsPerPage = this.entriesNumber;
    }
  }

  paginationEntries(event) {
    this.entriesNumber = event.target.value;
  }

  onSearch(value?: string) {
    if (!value) value = this.searchTerm.value;
    this.filterUser = [...this.users].filter(
      (nd) =>
        nd.userName?.toLowerCase().includes(value) ||
        nd.emailId?.toLowerCase().includes(value) ||
        nd.firstName?.toLowerCase().includes(value) ||
        nd.lastName?.toLowerCase().includes(value)
    );
    if (value)
      this.config.currentPage = 1;
  }

  deleteUsers() {
    this.usersList = [];
    this.multiSelectIndex.forEach((u) => {
      let index = this.users.map((m) => m.userName).indexOf(u);
      if (index !== -1) {
        let user = this.users[index];
        this.usersList?.push(user);
      }
    });
    if (this.usersList?.length < 1) {
      this.snackBar.open("No users selected", "Ok", { duration: 5000 });
      return;
    }
    const dialogRef = this.dialog.open(DeleteUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {
        depName: this.depName,
        userName: this.canDeleteUsers.join(","),
        message: "Do you want to delete the selected users ?",
        showNote: true,
        Users: this.usersList,
      },
    });
    dialogRef.afterClosed().subscribe((user) => {
      if (user) {
        this.spinner.show("userList");
        this.userService.deleteMultipleUser(this.usersList).subscribe({
          next: (data: any) => {
            this.snackBar.open(data.message, "Ok", { duration: 5000 });
            this.userService.reloadUserListOnAction(true);
            this.spinner.hide("userList");
          },
          error: (err: any) => {
            this.snackBar.open(
              err.error.message || "Action cannot be completed.",
              "Ok",
              { duration: 5000 }
            );
            this.spinner.hide("userList");
          },
        });
      } else {
      }
    });
  }

  checkSelectedCheckboxes(event, userName) {
    if (event.target.checked) {
      if (!this.multiSelectIndex.includes(userName)) {
        this.multiSelectIndex.push(userName);
        if (this.multiSelectIndex.length == this.users.length) {
          this.isSelectAll = true;
        }
      }
    } else {
      let idx = this.multiSelectIndex.indexOf(userName);
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.users.length
      ) {
        this.isSelectAll = false;
      }
    }
  }

  onSelectAllCheckBox(event) {
  const filteredUsers = this.filterUser;

    if (event.target.checked) {
      filteredUsers?.forEach((u, i) => {
        if (!this.multiSelectIndex.includes(u.userName)) {
          this.multiSelectIndex.push(u.userName);
        }
      });
      if (filteredUsers?.length == this.users.length) {
        this.isSelectAll = true;
      } else {
        this.isSelectAll = false;
      }
      return;
    } else {
      filteredUsers?.forEach((u, i) => {
        if (this.multiSelectIndex.includes(u.userName)) {
          let index = this.multiSelectIndex.indexOf(u.userName);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      if (filteredUsers?.length == this.users.length) {
        this.isSelectAll = false;
      }
      return;
    }
  }

  downloadDataAsCsv() {
    const fileName = "users.csv";

    const formattedUsers = this.users.map((user) => {
      const userDetailsFormatted =
        user.userDetails
          ?.map((detail) => {
            return `Deployment Name: ${detail.deploymentName}, User Role: ${detail.userRole}, Node Group: ${detail.nodeGroup}, Mapped Workstation: ${detail.mappedWorkstation}`;
          })
          .join("; ") || "";

      const userStartCommandFormatted =
        typeof user.userStartCommand === "object"
          ? JSON.stringify(user.userStartCommand)
          : user.userStartCommand || "";

      return {
        ...user,
        userDetails: userDetailsFormatted,
        attachedGroup: user.attachedGroup || "",
        userStartCommand: userStartCommandFormatted,
      };
    });

    this.csvExportService.downloadDataAsCsv(formattedUsers, fileName);
  }

  sortLoginTime() {
    this.loginTimeSort = !this.loginTimeSort;
    if (this.loginTimeSort) {
      this.filterUser = this.filterUser.sort((a, b) => {
        const dateA = a.lastLoginTime ? new Date(a.lastLoginTime) : new Date(0);
        const dateB = b.lastLoginTime ? new Date(b.lastLoginTime) : new Date(0);
        return dateA.getTime() - dateB.getTime();
      });
    } else {
      this.filterUser = this.filterUser.sort((a, b) => {
        const dateA = a.lastLoginTime ? new Date(a.lastLoginTime) : new Date(0);
        const dateB = b.lastLoginTime ? new Date(b.lastLoginTime) : new Date(0);
        return dateB.getTime() - dateA.getTime();
      });
    }
  }

  getSelectedUserNames() {
    return this.multiSelectIndex.map((u) => u.userName);
  }

  getBillingInput() {
    this.dialog
      .open(BillingInputComponent, {
        autoFocus: false,
        disableClose: true,
        width: "700px",
        data: {
          names: this.allUserNames,
          selectedNames: this.multiSelectIndex[0],
          isUsers: true,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.spinner.show("userList");
          this.showBillingPreview(res);
        }
      });
  }

  async showBillingPreview(res: any) {
    let user = this.users.find((u) => u.userName == res.names);
    let fullName =
      user.firstName &&
        user.firstName !== "null" &&
        user.firstName.trim() !== "" &&
        user.lastName &&
        user.lastName !== "null" &&
        user.lastName.trim() !== ""
        ? user.firstName + " " + user.lastName + " (" + user.userName + ")"
        : "(" + user.userName + ")";
    var consumptionData = await lastValueFrom(
      this.consumptionService.getBillingData(
        res.names,
        res.type,
        res.startDate,
        res.endDate,
        "User"
      )
    );
    if (consumptionData.length == 0) {
      this.snackBar.open(
        "No consumption data found for the selected user",
        "Ok",
        { duration: 5000 }
      );
      this.spinner.hide("userList");
      return;
    }
    this.dialog
      .open(BillingPreviewComponent, {
        autoFocus: false,
        disableClose: true,
        width: "70vw",
        // height: '90vh',
        data: {
          consumptionData: consumptionData,
          type: res.type,
          title: "Consumption Preview for User",
          fromDate: res.startDate,
          toDate: res.endDate,
          names: res.names,
          period: res.period,
          fullName,
        },
      })
      .afterClosed()
      .subscribe((res) => {});
    this.spinner.hide("userList");
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  editUser() {
    const dialogRef = this.dialog.open(UpdateUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "800px",
      height: "90vh",
      data: {
        ...this.userService.getUpdatedUserDetails()
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        // This will refresh the component 
        this.refreshComponent();

        // This will trigger the same toggleDetailsView for same user with updated details
        const routeNames = this.router.url.split('/')
        const rememberedUser = routeNames[routeNames.length-1];

        const elementId = rememberedUser + "-toggleDetailsView";
        let attempts = 0;

        // This is to get the html element so that we can trigger click action on it, 
        // the possibility where api call will take some time to load the users, 
        // because of that we are using setInterval to attempt 10 times to find the element
        const checkForElement = setInterval(() => {
          const element = document.getElementById(elementId);
          if (element) {
            element.click();
            clearInterval(checkForElement);
          } else if (attempts >= 10) {
            clearInterval(checkForElement);
          }
          attempts++;
        }, 500);

      }
    });
  }

  resetUserPassword() {
    if (this.loggedInUserRole != UserRoleNames.GlobalAdmin) {
      this.snackBar.open("Please Contact Admin To Change Password", "Ok", {
        duration: 5000,
      });
      return;
    }
    this.dialog.open(ResetPassConfirmationComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        selectedUser: this.selectedUser.userName,
        loggedInUser: this.authenticationService.currentUserValue.username,
      },
    });
  }

  deleteUser() {
    const dialogRef = this.dialog.open(DeleteUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "25%",
      data: {
        depName: this.depName,
        userName: this.selectedUser.userName,
        message:
          "Deleting the user will revoke its access from all the deployments and SyncHPC. Do you want to proceed ?",
        showNote: false,
        Users: null,
      },
    });
    dialogRef.afterClosed().subscribe((user) => {
      if (user) {
        this.spinner.show();
        this.userService.deleteUser(user).subscribe({
          next: (data: any) => {
            this.snackBar.open(data.message, "Ok", { duration: 5000 });
            this.userService.reloadUserListOnAction(true);
            // Close the details view and clear selected user
            this.detailsViewOpen = false;
            this.selectedUser = null;
            this.spinner.hide();
          },
          error: (err: any) => {
            this.snackBar.open(
              err.error.message || "Action cannot be completed.",
              "Ok",
              { duration: 5000 }
            );
            this.spinner.hide();
          },
        });
      }
    });
  }

  configureNotifications() {
    const dialogRef = this.dialog.open(NotificationConfigurationComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: { userId: this.selectedUser.userName },
    });
  }
  getActiveFiltersCount(): number {
    let count = 0;
    const formValues = this.filterForm.value;

    if (formValues.deployment !== 'All') count++;
    if (formValues.userRole !== 'All') count++;
    if (formValues.allocatedCores !== 'All') count++;
    if (formValues.machine !== 'All') count++;

    return count;
  }
  checkAccessToShow(user: Users){ 
    if(user.userRole == UserRolesInt.GlobalAdmin.toString())  return 'GlobalAdmin';
    else if( user.userRole == UserRolesInt.Reader.toString())  return 'Reader';
    else if(  user.userDetails[0]?.deploymentName != null  ) return 'select';
    else return 'NoContent';
  }

  getUserRole(userrole){
    return UserRoleNames[UserRolesInt[userrole]];
  }
}
